import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import axios from '../../shared/axios';

import withErrorHandler from '../../hoc/with-error-handler';
import { AppDispatch } from '../../store';
import SmsMessages from './sms-messages';
import * as actions from './store/actions';

import './styles.less';

const SMSesComponent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current) {
      dispatch(actions.getMessageControlParameters());
      didMount.current = true;
    }
  }, []);

  return (
    <div className="smses-component">
      <SmsMessages />
      <div className="smses-component-footer"></div>
    </div>
  );
};

export default withErrorHandler(SMSesComponent, axios);
